import { RelayState } from '@/store/modules/relay/relayState';
import { RelayConnection } from '@/core/interfaces/relayConnection';
import { RelayMachine } from '@/core/interfaces/relayMachine';

const mutations = {
    addRelayServer(state: RelayState, payload: {server: string; connections: RelayConnection[]; machines: RelayMachine[]}) {
        state.relays = state.relays.filter(relay => relay.server !== payload.server);
        state.relays.push(payload);
    },

    setActiveServer(state: RelayState, payload: string) {
        state.activeServer = payload;
    },
};

export default mutations;
